export class Access{
  id:number;
  description:string;
  value:boolean;
}